import React, { Component } from "react";
import { connect } from "react-redux";
import { updateUser } from "../../../../actions/user.actions";
import Settings from "../components/Settings";
import { getUserData } from "../../../../actions/user.actions";
import Toast from "../../../../components/common/toast/Toast";

class SettingsContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && this.props.user) {
      const nextData = nextProps.user;
      const thisData = this.props.user;

      if (
        nextData.email !== thisData.email ||
        nextData.password !== thisData.password ||
        nextData.first_name !== thisData.first_name ||
        nextData.last_name !== thisData.last_name
      ) {
        this.props.getUserData();
      }
    }
  }

  componentDidMount() {
    this.props.getUserData();
  }

  handleSubmit(data) {
    this.toast.showToast();
    this.props.updateUserData(data);
  }

  render() {
    let userData = {};
    ({
      user: {
        first_name: userData.first_name,
        last_name: userData.last_name,
        email: userData.email
      }
    } = this.props);

    return (
      <div>
        <Toast
          onRef={ref => (this.toast = ref)}
          title="Your profile edits have been saved."
        />
        <Settings onSubmit={this.handleSubmit} userData={userData} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  getUserData: () => dispatch(getUserData()),
  updateUserData: (user, redirect) => {
    dispatch(updateUser(user, redirect));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/settings/containers/SettingsContainer.js